import * as React from 'react';

function SvgMail(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M19.5 4.15h-15A2.503 2.503 0 002 6.65v10.715a2.503 2.503 0 002.5 2.5h15a2.503 2.503 0 002.5-2.5V6.65a2.503 2.503 0 00-2.5-2.5zm-.633 4.136l-6.429 5a.715.715 0 01-.876 0l-6.429-5a.714.714 0 11.877-1.128L12 11.817l5.99-4.659a.714.714 0 01.877 1.128z" })));
}

export default SvgMail;
